import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { Tooltip } from '../../../common/tooltip'
import { selectProfileById } from '../store/slice'

export const ProfileNameCell = ({ rowId, name }) => {
  const setSearchParams = useSearchParams()[1]

  const profileSetting = useSelector(selectProfileById(rowId))
  const isFollowingProfile = profileSetting.isFollowingList

  const handleClick = () => {
    setSearchParams({ profileId: rowId })
  }

  return (
    <Element className="dFlex alignItemsCenter breakWordAll pr3">
      <Element
        className="cursorPointer wFitContent"
        style={{ color: '#2C73E8' }}
        onClick={handleClick}
      >
        <TextEllipsisStaticLine
          text={name}
          isI18n={false}
          tooltipMaxWidthByContent
        />
      </Element>
      {isFollowingProfile && (
        <Tooltip
          tooltipContent="alertSetting.TOOLTIP_FOLLOWING_PROFILE"
          isI18n
          contentClass="ml1"
          tooltipStyle={{ maxWidth: 400, textAlign: 'justify' }}
        >
          <Icon
            className="icon-info-circle"
            style={{ fontSize: 12, color: '#9c9c9c' }}
          />
        </Tooltip>
      )}
    </Element>
  )
}
